module.exports = __webpack_public_path__ + "static/ZenithSlabDJRColorSVG-Regular-b3f9ddf3fefeeba7a1faa647220ab13e.woff";